import { Color } from "../enums/Color";

export const diplomaEditPage = {    
    mobile: {
        label: {
            fontSize: "3.86vw",            
            color: Color.DeepAsh,
            margin: "0 0 1.21vw 3.62vw"
        },
        input: {
            wrapper: {
                margin: "auto",
                alignItems: "center"
            },               
            input: { 
                height: "11.08vw",
                padding: "0 3.62vw",                    
                fontSize: "3.86vw",
                border: "2px solid " + Color.Green,
                borderRadius: "1.21vw",
                borderBottom: "2px solid " + Color.Green
            }
        },
        editor: {
            height: "unset",
            minHeight: "60.86vw",            
            border: "0.24vw solid" + Color.Green,
            borderRadius: "1.21vw"
        },
        submitButton: {            
            background: Color.Green,
            color: Color.White,
            border: "none",
            fontWeight: "bold"
        },
        responseDialog: {            
            backdrop: {
                backgroundColor: Color.Black,
                opacity: 0.15,
                position: "fixed" as "fixed",
                left: "0",
                right: "0",
                bottom: "0",
                top: "0"
            },
            content: {
                background: Color.White,
                position: "fixed",
                top: "35%",
                right: "5%",
                width: "80%",
                padding: "10px 5%",                        
                borderRadius: "10px",
                zIndex: "2",
                boxShadow: "1px 0px 7px rgba(0,0,0,0.5)",  
                transform: "translateX(0)"
            }
        }
    },
    desktop: {
        margin: "0.83vw 4% 4% 4%",  
        titleWrapper: {
            justifyItems: "center"
        },
        title: {
            margin: 0
        },
        rowWrapper: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginTop: "2.18vw"
        },
        searchSelect: {        
            wrapper: {   
                width: "27.08vw",            
                marginLeft: "unset"          
            },
            label: {
                fontSize: "1.20vw"
            },
            hover: {
                width: "26.56vw",
                height: "17.70vw",
                left: "unset",
                padding: "0.26vw 0.26vw 1.04vw 0.26vw"
            }
        },
        label: {
            fontSize: "0.94vw",
            margin: "0 0 0.52vw 0.52vw"
        },        
        input: {              
            input: { 
                width: "25.36vw",
                height: "2.4vw",
                padding: "0 0.86vw",
                fontSize: "0.83vw",
                borderRadius: "0.52vw"
            }
        },
        editor: {
            minHeight: "22.76vw",
            width: "27.08vw",
            border: "2px solid" + Color.Green,
            borderRadius: "0.52vw"
        },
        switchWrapper: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            marginTop: "2.18vw"
        },
        switchLabel: {
            marginRight: "0.83vw"
        },
        switch: {
            switch: {
                margin: "unset"
            }
        },
        buttonWrapper: {
            display: "flex",
            justifyContent: "flex-end"
        },
        submitButton: {
            height: "3.12vw",
            width: "27.08vw",            
            borderRadius: "0.52vw",            
            fontSize: "1.04vw",
            margin: "2.08vw 0 0 0"
        },
        responseDialog: {
            content:{
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "36%",
                padding: "2%",
                borderRadius: "0.52vw",
                boxShadow: "1px 0px 7px rgba(0,0,0,0.5)"
            }
        },
        responseButton: {
            backgroundColor: Color.Green,
            color: Color.White,
            borderRadius: "0.52vw",
            padding: "0.625vw 1.25vw",
            float: "right"
        }
    }
}